"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGamblerSettings = exports.changeGamblerSetting = exports.changeGamblerSettings = exports.deleteKey = void 0;
var core_1 = __importDefault(require("@gin-betting/core"));
var lodash_1 = require("lodash");
var constants_1 = require("./constants");
var utils_1 = require("./utils");
var getBettingOptions = core_1.default.utils.getBettingOptions;
var deleteKey = function (key) { return function (dispatch) {
    if (!getBettingOptions().isAuthorized)
        return;
    dispatch({
        type: constants_1.DELETE_GAMBLER_SETTING_REQUEST,
        payload: {
            method: 'deleteGamblerSetting',
            variables: {
                key: key,
            },
        },
        meta: {
            isApiCall: true,
        },
    });
}; };
exports.deleteKey = deleteKey;
var changeGamblerSettings = function (changedSettings) { return function (dispatch) {
    if (!getBettingOptions().isAuthorized)
        return;
    dispatch({
        type: constants_1.CHANGE_GAMBLER_SETTINGS_REQUEST,
        payload: {
            method: 'changeGamblerSettings',
            variables: {
                changedSettings: lodash_1.map(changedSettings, function (value, name) { return ({
                    name: name,
                    value: utils_1.convertClientSettingValue(value),
                }); }),
            },
        },
        meta: {
            isApiCall: true,
        },
    });
}; };
exports.changeGamblerSettings = changeGamblerSettings;
// IMPORTANT! For use this action in app is need override types
// example:
// class TYPE_MAP_KEY_VALUE implements Record<KEYS_ENUM, unknown> {
//     [KEYS_ENUM.KEY]: TYPE;
// }
// const typedChangeGamblerSetting: GamblerSettings.MakeChangeGamblerSetting<TYPE_MAP_KEY_VALUE> = changeGamblerSetting;
var changeGamblerSetting = function (key, value) { return function (dispatch) {
    if (!getBettingOptions().isAuthorized)
        return;
    var convertedValue = utils_1.convertClientSettingValue(value);
    dispatch({
        type: constants_1.CHANGE_GAMBLER_SETTING_REQUEST,
        payload: {
            method: 'changeGamblerSetting',
            variables: {
                key: key,
                value: convertedValue,
            },
        },
        meta: {
            isApiCall: true,
        },
    });
}; };
exports.changeGamblerSetting = changeGamblerSetting;
var getGamblerSettings = function () {
    return {
        type: constants_1.GET_GAMBLER_SETTINGS_REQUEST,
        payload: {
            method: 'getGambler',
            variables: {
                gambler: null,
            },
        },
        meta: { isApiCall: true },
    };
};
exports.getGamblerSettings = getGamblerSettings;
//# sourceMappingURL=actions.js.map